export * from './infobox.module';
export { InfoboxButton } from './infobox.component';
export { InfoboxType } from './infobox.component';
